import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Calendar from 'srcReact/components/Widgets/Calendar'
import FeaturedDoc from 'srcReact/components/Widgets/FeaturedDoc'
import GetToMeet from 'srcReact/components/Widgets/GetToMeet'
import InterestSuggestion from 'srcReact/components/Widgets/InterestSuggestion'
import LightProfileModal from 'srcReact/components/common2/LightProfileModal'
import FileNavigationPopup from 'srcReact/components/common2/FileNavigationPopup'
import RandomItems from 'srcReact/components/Widgets/RandomItems'

function Widgets({
  tab,
  groupId,
  widgets,
  mixrs,
  loggedInUser,
  isStaffMember,
  selectTab,
  handleRemoveCoorganizer,
  handleAddCoorganizer,
  removeFromGroup
}) {
  const { t } = useTranslation()
  const [featuredDocs, setFeaturedDocs] = useState(null)
  const [suggestions, setSuggestions] = useState(null)
  const [getToKnow, setGetToKnow] = useState(null)
  const [latestMedia, setLatestMedia] = useState(null)
  const [getToMeet, setGetToMeet] = useState(null)

  const [isImageOpen, setIsImageOpen] = useState(false)
  const [image, setImage] = useState(null)

  const [modalData, setModalData] = useState({
    isShowUserModal: false,
    selectedModalUser: {},
    selectedModalUserIndex: 0
  })

  const hideUserModal = () => {
    setModalData({
      ...modalData,
      isShowUserModal: false
    })
  }

  const showUserModal = (user, userIndex, users) => {
    setModalData({
      isShowUserModal: true,
      selectedModalUser: user,
      selectedModalUserIndex: userIndex
    })
  }

  const navigate = (direction) => {
    let nextUserIndex =
      direction === 'next' ? modalData.selectedModalUserIndex + 1 : modalData.selectedModalUserIndex - 1
    if (nextUserIndex > getToMeet.length - 1) {
      nextUserIndex = 0
    } else if (nextUserIndex < 0) {
      nextUserIndex = getToMeet.length - 1
    }
    setModalData({
      ...modalData,
      selectedModalUserIndex: nextUserIndex,
      selectedModalUser: getToMeet[nextUserIndex]
    })
  }

  useEffect(() => {
    if (widgets) {
      setFeaturedDocs(widgets.featured_documents)
      setSuggestions(widgets.suggested_interest)
      setGetToMeet(widgets.get_to_meet)
      setGetToKnow(widgets.get_to_know)
      setLatestMedia(widgets.latest_media)
    }
  }, [groupId, widgets])
  const getOptionsBasedOnRole = () => {
    let options = []
    if (loggedInUser.id !== modalData.selectedModalUser.id) {
      if (isStaffMember) {
        if (modalData.selectedModalUser.role === 'co-organizer') {
          options.push({
            text: t('mixrHome.members.removeRole'),
            onClick: () => handleRemoveCoorganizer(modalData.selectedModalUser.id)
          })
        } else if (
          modalData.selectedModalUser.role === 'participant' ||
          modalData.selectedModalUser.role === 'member'
        ) {
          options.push({
            text: t('mixrHome.members.addCoOrganizer'),
            onClick: () => handleAddCoorganizer(modalData.selectedModalUser.id)
          })
        }
        if (modalData.selectedModalUser.role !== 'none') {
          options.push({
            text: t('groupHome.members.removeMember'),
            onClick: () => removeFromGroup(modalData.selectedModalUser.id)
          })
        }
      }
    }
    return options
  }

  const showImageModal = (img) => {
    setIsImageOpen(true)
    setImage(img)
  }

  const closeImageModal = () => {
    setIsImageOpen(false)
  }

  return (
    <React.Fragment>
      <Calendar groupId={groupId} mixrs={mixrs} selectTab={selectTab} isStaffMember={isStaffMember} />
      {tab === 'media' && (
        <React.Fragment>
          {/* {featuredDocs?.length > 0 && (
            <FeaturedDoc
              type='group'
              id={groupId}
              documents={featuredDocs}
              handleShowMore={() => selectTab('media', 'documents_media')}
            />
          )} */}
          {latestMedia?.length > 0 && (
            <RandomItems
              type='latestmedia'
              title={t('widgets.latestMedia')}
              items={latestMedia}
              imageName='media'
              showImageModal={showImageModal}
            />
          )}
        </React.Fragment>
      )}
      {tab === 'feed' && (
        <React.Fragment>
          {/* {featuredDocs?.length > 0 && (
            <FeaturedDoc
              type='group'
              id={groupId}
              documents={featuredDocs}
              handleShowMore={() => selectTab('media', 'documents_media')}
            />
          )} */}

          {suggestions?.length > 0 && (
            <InterestSuggestion suggestions={suggestions} handleShowMore={() => selectTab('info')} />
          )}
        </React.Fragment>
      )}
      {tab === 'info' && (
        <React.Fragment>
          {suggestions?.length > 0 && (
            <InterestSuggestion suggestions={suggestions} handleShowMore={() => selectTab('info')} />
          )}
        </React.Fragment>
      )}
      {tab === 'mixrs' && getToMeet?.length > 0 && (
        <GetToMeet participants={getToMeet} showUserModal={showUserModal} showMixrUrl={true} />
      )}
      {tab === 'members' && getToKnow?.length > 0 && (
        <GetToMeet
          title={t('widgets.getToMeet.titleGetToKnow')}
          participants={getToKnow}
          showProfileUrl={true}
          showUserModal={showUserModal}
        />
      )}

      {modalData.isShowUserModal && (
        <LightProfileModal
          userIdwithRole={modalData.selectedModalUser.id}
          show={modalData.isShowUserModal}
          userswithRole={modalData.selectedModalUserIndex ? getToMeet : null}
          userIndexWithRole={modalData.selectedModalUserIndex}
          roleManagementOptions={getOptionsBasedOnRole()}
          closeModalWithRole={hideUserModal}
          navigateWithRole={navigate}
        />
      )}

      {isImageOpen && image && (
        <FileNavigationPopup
          isOpen={isImageOpen}
          file={image}
          fileIndex={-1}
          files={null}
          closeModal={closeImageModal}
          enableDeleteFile={false}
          plain={true}
        />
      )}
    </React.Fragment>
  )
}

export default Widgets
